import {ListItem, Text} from '@chakra-ui/react';
import {Price} from 'components/shared';
import {useTranslation} from 'hooks';
import {FC} from 'react';

interface IProps {
  price?: number;
  range?: number[];
}

export const NightSurcharge: FC<IProps> = ({price, range}) => {
  const {t} = useTranslation();
  if (!price) return null;

  const replaceRegex = range
    ? t('nightSurcharge').replace('00:00', `${range[0]}:00`).replace('06:00', `${range[1]}:00`)
    : '';
  return (
    <ListItem
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      py="15px"
      borderBottom="1px solid #E6E6E6"
    >
      <Text maxWidth="80%" as="span" fontWeight="500" fontSize={['14px', '18px']}>
        {replaceRegex}
      </Text>
      <Price
        value={price}
        priceProps={{
          fontWeight: '500',
        }}
      />
    </ListItem>
  );
};
